/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_geohash.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts an input value to a `geohash` value.
 * A string will only be successfully converted if it respects the
 * `geohash` format, as described for the
 * geohash grid aggregation.
 *
 * @example
 * ROW string = "u3bu"
 * | EVAL geohash = TO_GEOHASH(string)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_geohash',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'geohash',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geohash',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geohash',
    },
    {
      params: [
        {
          name: 'field',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geohash',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geohash',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
